import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Start")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_result = _resolveComponent("el-result")

  return (_openBlock(), _createBlock(_component_el_result, {
    icon: "success",
    title: "Congratulations!",
    subTitle: "You have completed the AccidentPlan setup."
  }, _createSlots({ _: 2 }, [
    (!_ctx.isInGeotabSetupTestMode)
      ? {
          name: "extra",
          fn: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _ctx.onNext,
              size: "medium"
            }, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        }
      : undefined
  ]), 1024))
}